import { parseISO } from 'date-fns'

export const transformDate = (currentValue, originalValue) => parseISO(originalValue)
